import { Outlet } from 'react-router-dom'

const RateConfigurationsPage = () => {
  return <Outlet />
}

export default RateConfigurationsPage
